const _excluded = ["id", "hash", "email", "avatarUrl", "firstName", "lastName", "locale", "createdAt", "isCreatorNetwork"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
class Intercom {
  constructor() {
    this._appId = undefined;
    this._user = undefined;
  }
  _normalizeUser(user) {
    if (!user) {
      return {
        app_id: this._appId
      };
    }
    const id = user.id,
      hash = user.hash,
      email = user.email,
      avatarUrl = user.avatarUrl,
      firstName = user.firstName,
      lastName = user.lastName,
      locale = user.locale,
      createdAt = user.createdAt,
      isCreatorNetwork = user.isCreatorNetwork,
      rest = _objectWithoutProperties(user, _excluded);
    const nameParts = [firstName, lastName].filter(Boolean);
    const name = nameParts.length ? nameParts.join(' ') : undefined;
    const createdAtInSeconds = createdAt ? new Date(createdAt).getTime() / 1000 : undefined;
    return Object.assign({}, rest, {
      app_id: this._appId,
      user_id: id,
      user_hash: hash,
      email,
      name,
      created_at: createdAtInSeconds,
      language_override: locale,
      avatar: avatarUrl && {
        type: 'avatar',
        image_url: avatarUrl
      },
      isCreatorNetwork: user.isCreatorNetwork
    });
  }
  init({
    appId,
    user
  }) {
    // eslint-disable-next-line no-console
    console.log('Intercom.init is deprecated. Please use Intercom.load and Intercom.boot instead.');
    this.load(appId);
    this.boot(user);
  }
  load(appId) {
    this._appId = appId;
    if (window.Intercom) {
      return;
    }

    // prettier-ignore
    // eslint-disable-next-line
    (function () {
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === "function") {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        var d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function () {
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/' + appId;
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    })();
  }
  boot(user) {
    if (!window.Intercom) {
      // eslint-disable-next-line no-console
      console.log('Intercom not loaded. Skipping boot()');
      return;
    }
    if (user) {
      this._user = Object.assign({}, this._user, user);
    }
    window.Intercom('boot', this._normalizeUser(this._user));
  }
  update(user) {
    if (!window.Intercom) {
      // eslint-disable-next-line no-console
      console.log('Intercom not loaded. Skipping update()');
      return;
    }
    if (user) {
      this._user = Object.assign({}, this._user, user);
    }
    window.Intercom('update', this._normalizeUser(this._user));
  }
  shutdown() {
    if (!window.Intercom) {
      // eslint-disable-next-line no-console
      console.log('Intercom not loaded. Skipping shutdown()');
      return;
    }
    this._user = undefined;
    window.Intercom('shutdown');
  }
  show() {
    if (!window.Intercom) {
      // eslint-disable-next-line no-console
      console.log('Intercom not loaded. Skipping show()');
      return;
    }
    window.Intercom('show');
  }
  hide() {
    if (!window.Intercom) {
      // eslint-disable-next-line no-console
      console.log('Intercom not loaded. Skipping hide()');
      return;
    }
    window.Intercom('hide');
  }
}
export default new Intercom();